import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from 'vue';
import i18n from './i18n.js';
import vuetify from './plugins/vuetify.plugin.js';
import VueRouter from 'vue-router';
import axios from 'axios';
import auth, {keycloakClient} from './auth';
import user from './user';

import App from './App.vue';
import store from './store';
import routes from './routes';
import ValidationPlugin from './plugins/validation.plugin';
import LocalePlugin from './plugins/locale.plugin';
import DateFormatPlugin from './plugins/dateformat.plugin';
import UserPlugin from './plugins/user.plugin';
import HelperPlugin from './plugins/helper.plugin';

import BackButton from './components/BackButton.vue';
import MainMenuButton from './components/MainMenuButton.vue';
import LoadingIndicator from './components/LoadingIndicator.vue';
import FilterDrawer from './components/FilterDrawer.vue';
import IconSharp from './components/IconSharp.vue';
import LanguageSelector from './components/LanguageSelector.vue';
import numeral from 'numeral'
import gallery from 'img-vuer';

//import './registerServiceWorker';
import database from '@/database';
import LoggedOutView from "@/views/LoggedOutView.vue";

require('numeral/locales/fi');


numeral.locale('fi');
numeral.zeroFormat('0');
numeral.nullFormat('');
auth.success = initApp;

function tokenInterceptor(auth) {
  axios.interceptors.request.use(
    config => {
      if (auth.client && auth.client.authenticated) {
        config.headers.Authorization = `Bearer ${auth.accessToken}`;
        config.headers['X-JWT-IDTOKEN'] = `${auth.idToken}`; // TODO: might be needed in /api/UserRole for authorization based on attributes not just email to save some calls
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
}

function refreshToken() {
  return auth.client.updateToken(120); // do refresh when equal or less than 2 minutes left
}

function accessDeniedInterceptor(auth) {
  return new Promise((resolve, reject) => {
    axios.interceptors.response.use(
      response => {
        resolve(response);
        return response;
      },
      error => {
        if (error.response && error.response.status === 401) {

          console.log('accessDeniedInterceptor error', error.response.headers['www-authenticate']);


          const isTokenExpired =
            error.response &&
            error.response.headers['www-authenticate'] &&
            error.response.headers['www-authenticate'].indexOf('token is expired') !== -1;
          console.log('isTokenExpired', isTokenExpired);
          if (isTokenExpired) {
            refreshToken(); //TODO: return promise? this is far fetched scenario because of refreshToken should be called timely
            reject(error);
            return Promise.reject(error);
          } else {
            reject(error);
            return Promise.reject(error);
          }
        } else {
          reject(error);
          return Promise.reject(error);
        }
      }
    );
  })

}

const router = new VueRouter({routes});
if (window.location.hash !== '#/loggedout') {
  auth.init();
  tokenInterceptor(auth);
  accessDeniedInterceptor(auth).catch(error => {
    console.log('accessDeniedInterceptor error', error);
    keycloakClient.logout();
    //window.location = '/#/loggedout'

  });
} else {
  const vue = new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: h => h(LoggedOutView),
  });

  vue.$mount('#app');
  auth.logout()
}


async function sendSyncCommand() {
  // Syncmanager ei firefoxissa
  if ('serviceWorker' in navigator && 'SyncManager' in window) {
    const sw = await navigator.serviceWorker.ready;
    console.log('register sync');
    await sw.sync.register('sync-tehtava-attachments');
  }
}

function initApp(authenticated) {
  //console.log('authenticated', authenticated);
  database.setSettings(auth.accessToken).then(() => {
    //return sendSyncCommand();
  });
  setInterval(refreshToken, 1000 * 60);

  Vue.config.productionTip = false;

  Vue.use(VueRouter); //at least this must be after auth init, else router fails
  Vue.use(ValidationPlugin);
  Vue.use(LocalePlugin);
  Vue.use(DateFormatPlugin);
  Vue.use(UserPlugin);
  Vue.use(HelperPlugin);

  Vue.use(gallery, {
    swipeThreshold: 100, // default 100
    isIndexShow: true, // show image index, default true
    useCloseButton: true, // trigger gallery close with close button, default true
    preload: true, // preload images in the same group, default true
    sliderBackgroundColor: 'rgba(0,0,0,0.9)',
    sliderZIndex: 1001,
  });

  user.vuetify = vuetify;
  user.user = auth.strategiaUser;


  Vue.component('hb-back-button', BackButton);
  Vue.component('hb-main-menu-button', MainMenuButton);
  Vue.component('hb-loading-indicator', LoadingIndicator);
  Vue.component('hb-filter-drawer', FilterDrawer);
  Vue.component('hb-language-selector', LanguageSelector);
  Vue.component('hb-icon', IconSharp);


  store.dispatch('reloadSystemData').then(() => {
    const vue = new Vue({
      vuetify,
      router,
      store,
      i18n,
      render: h => h(App),
    });

    vue.$mount('#app');
  });
}

function tokenRefresh() {
}
